module.exports = __webpack_public_path__ + "Averta-Semibold.8b8c9bf9314cd2c8071f.woff";


//////////////////
// WEBPACK FOOTER
// /Users/nolanclark/Desktop/Development/GoPark/src/fonts/Averta-Semibold.woff
// module id = ../../../../../src/fonts/Averta-Semibold.woff
// module chunks = styles